import { type ReactNode } from 'react';

export interface NavItem {
  key: string;
  label: string;
  icon?: ReactNode;
  active?: boolean;
}

export interface SideNavProps {
  examTitle: string;
  examTarget: string;
  items: NavItem[];
  activeKey: string;
  onNavigate: (key: string) => void;
  footer?: ReactNode;
}

export function SideNav({
  examTitle,
  examTarget,
  items,
  activeKey,
  onNavigate,
  footer,
}: SideNavProps) {
  return (
    <aside className="w-[232px] h-full bg-surface-secondary flex flex-col border-r border-sage-300">
      {/* Exam context header */}
      <div className="px-7 pt-7 pb-4">
        <h2 className="font-serif text-lg font-bold text-ink-primary">{examTitle}</h2>
        <p className="font-sans text-sm text-ink-tertiary mt-1">{examTarget}</p>
      </div>

      {/* Divider */}
      <div className="mx-7 h-px bg-sage-300" />

      {/* Navigation items */}
      <nav className="flex-1 px-5 pt-4 space-y-1">
        {items.map((item) => (
          <button
            key={item.key}
            onClick={() => onNavigate(item.key)}
            className={`
              w-full flex items-center gap-3 px-4 py-2 rounded-md text-sm font-medium transition-colors
              ${
                item.key === activeKey
                  ? 'bg-shell text-white'
                  : 'text-ink-secondary hover:bg-sage-50'
              }
            `}
          >
            {item.icon && <span className="w-5 h-5">{item.icon}</span>}
            {item.label}
          </button>
        ))}
      </nav>

      {/* Footer area (e.g. training loop, entitlement info) */}
      {footer && (
        <div className="mx-5 mb-5 p-4 bg-sage-50 rounded-lg text-xs text-ink-muted">{footer}</div>
      )}
    </aside>
  );
}
